import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
import Glide from "@glidejs/glide";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

const header = document.getElementById("js-header");
const headerToggle = document.getElementById("js-header-toggle");
let headerOpen = false;
let hasScrolled = false;
const animationDuration = 1000;
const animationTimingFunc = "cubic-bezier(0.4, 0, 0.2, 1)";

let mm = gsap.matchMedia();
let pageScrollDirection = 1;

let smoother = ScrollSmoother.create({
  smooth: 0,
  effects: true,
});

mm.add("(min-width: 1024px)", () => {
  const headerHeight = header.offsetHeight;
  const triggerArea = headerHeight;

  window.addEventListener("mousemove", function (e) {
    if (e.clientY < triggerArea) {
      header.setAttribute("data-direction", "up");
      pageScrollDirection = -1;
      if (header.getAttribute("data-top") !== "disabled") {
        header.setAttribute("data-top", window.scrollY < 50 ? "true" : "false");
      }
    }
  });
});

document.querySelectorAll("[hero-parallax-pin]").forEach((instance) => {
  // Clamp is used below to ensure the parallax only starts when user scrolls, even if it loads past the 'start' parameters... nifty!
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: instance,
      start: "clamp(top center)",
      end: "bottom top",
      scrub: true,
    }
  });

  console.log("Setting parallax...");

  instance.querySelectorAll('[hero-parallax]').forEach(layer => {
    const depth = layer.dataset.depth;
    const movement = -(layer.offsetHeight * depth)
    tl.to(layer, {y: (window.innerHeight / 3), x: '0', ease: "linear"}, 0)
  });
});

document.querySelectorAll("[data-fadein]").forEach((instance) => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: instance,
      // markers: true,
      toggleActions: "play pause play pause",
    },
  });

  tl.set(instance, {
    opacity: 0,
    y: 30,
    autoAlpha: 1,
  });

  tl.to(instance, {
    opacity: 1,
    y: 0,
    delay: 0.125,
    ease: animationTimingFunc,
  });
});

document.querySelectorAll("[data-fadein-left]").forEach((instance) => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: instance,
      // markers: true,
      toggleActions: "play pause play pause",
    },
  });

  tl.set(instance, {
    opacity: 0,
    x: -50,
    autoAlpha: 1,
  });

  tl.to(instance, {
    opacity: 1,
    x: 0,
    delay: 0.125,
    ease: animationTimingFunc,
  });
});

document.querySelectorAll("[data-fadein-right]").forEach((instance) => {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: instance,
      // markers: true,
      toggleActions: "play pause play pause",
    },
  });

  tl.set(instance, {
    opacity: 0,
    x: 50,
    autoAlpha: 1,
  });

  tl.to(instance, {
    opacity: 1,
    x: 0,
    delay: 0.125,
    ease: animationTimingFunc,
  });
});

ScrollTrigger.create({
  trigger: "body",
  onUpdate: (self) => {
    // Enable/disable header 'scroll' state based on whether user is scrolling up or down
    if (window.scrollY > 0) {
      header.setAttribute(
        "data-direction",
        self.direction == 1 ? "down" : "up"
      );

      pageScrollDirection = self.direction;
    } else {
      hasScrolled = true;
    }

    // Set as 'top' if user is at top of window to re-enable clear nav state
    if (header.getAttribute("data-top") !== "disabled") {
      header.setAttribute("data-top", window.scrollY < 50 ? "true" : "false");
    }
  },
});

/**
 * Handle header mobile toggle
 */
headerToggle.addEventListener("click", () => {
  header.setAttribute("data-mobile-state", headerOpen ? "closed" : "open");
  // if (headerOpen) {
  //   header.setAttribute("style", "");
  // } else {
  //   header.style.minHeight = `${window.innerHeight}px`;
  // }
  headerOpen = !headerOpen;
});

document.querySelectorAll(".js-splitlines").forEach((el) => {
  const splitText = new SplitText(el, {
    type: "lines",
    tag: 'span',
    linesClass:
      "rounded-md bg-[#0026F0]/90 mix-blend-multiply py-3 px-4 md:px-8",
  });
});

/**
 * Handle single product tab accordion functionality
 */
if (document.querySelector(".item_accordion")) {
  const tabs = document.querySelectorAll(".item_accordion--target");
  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const parent = tab.closest(".item_accordion");
      const state = parent.getAttribute("data-state");

      if (state == "active") {
        parent.setAttribute("data-state", "inactive");
      } else {
        parent.setAttribute("data-state", "active");
      }
    });
  });
}

// Initiate sitewide Glide carousels
const initGlideCarousels = () => {
  const carouselClasses = [
    ".js-glide-content-image",
    ".js-glide-tiles-carousel",
  ];

  carouselClasses.forEach((v) => {
    document.querySelectorAll(v).forEach((instance) => {
      if (v == ".js-glide-content-image") {
        const carousel = new Glide(instance, {
          animationDuration: animationDuration,
          animationTimingFunc: animationTimingFunc,
          type: "carousel",
          perView: 3,
          gap: 140,
          breakpoints: {
            1440: {
              gap: 70,
            },
            1024: {
              perView: 2,
              gap: 30,
            },
            768: {
              perView: 1,
              gap: 20,
            },
          },
          autoHeight: true,
        });

        carousel.mount();
      }
      if (v == ".js-glide-tiles-carousel") {
        const slider = new Glide(instance, {
          type: "carousel",
          animationDuration: animationDuration,
          animationTimingFunc: animationTimingFunc,
          perView: 2,
          gap: 30,
          breakpoints: {
            650: {
              perView: 1,
              gap: 30,
            },
          },
          autoHeight: true,
        });

        slider.mount();
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  initGlideCarousels();
});
